module.exports = __webpack_public_path__ + "static/media/chat_icon.1c0842d4.svg";